import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { NoDataComponent } from 'ngx-lib';

@Component({
    selector: 'app-forbidden',
    templateUrl: './forbidden.component.html',
    styleUrls: ['./forbidden.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NoDataComponent]
})
export class ForbiddenComponent {
    constructor(private readonly router: Router) {}

    onLinkActionClicked() {
        this.router.navigate(['/dashboard']);
    }
}
